import React, { Component } from 'react';
// import logo from './logo.svg';
import 'bootstrap/dist/css/bootstrap.min.css';
import Slidenavbar from './Slidenavbar'
import home from './home'
import About from './About'
import Branding from './Branding'
import Service from './Service'
import Fouthsection from './Component/Fouthsection'
import Works from './Works'
import Contact from './Contact'
import Wacha from './Works/Wacha'
import {  BrowserRouter, Route } from 'react-router-dom'
import Brainshare from './Works/Brainshare';
import Soe from './Works/Soe';
import Bmc from './Works/Bmc';
import Wowbii from './Works/Wowbii';
import Photoma from './Works/Photoma';
import WachaTv from './Works/WachaTv';
import Suitscomng from './Works/Suitscomng';
import Roadbuddies from './Works/Roadbuddies';
import Pup from './Works/Pup';
import Homelove from './Works/Homelove';
import Stalert from './Works/Stalert';
import Acebank from './Works/Acebank';
import Roava from './Works/Roava';


class App extends Component {
 render () {
  return (
    <BrowserRouter>
    <Slidenavbar/>
    <div className="App">
      
    <Route path='/' exact component={home} />
      <Route path='/home' component={home} />
      <Route path='/about' component={About} />
      <Route path='/Branding' component={Branding} />
      <Route path='/Component/Fouthsection' component={Fouthsection} />
      <Route path='/Works' component={Works} />
      <Route path='/Service' component={Service} />
      <Route path='/Contact' component={Contact} />
      <Route path='/Wacha' component={Wacha} />
      <Route path='/Brainshare' component={Brainshare} />
      <Route path='/Soe' component={Soe} />
      <Route path='/Bmc' component={Bmc} />
      <Route path='/Wowbii' component={Wowbii} />
      <Route path='/Photoma' component={Photoma} />
      <Route path='/WachaTv' component={WachaTv} />
      <Route path='/Suitscomng' component={Suitscomng} />
      <Route path='/Roadbuddies' component={Roadbuddies} />
      <Route path='/Pup' component={Pup} />
      <Route path='/Homelove' component={Homelove} />
      <Route path='/Stalert' component={Stalert} />
      <Route path='/Acebank' component={Acebank} />
      <Route path='/Roava' component={Roava} />
    </div>
    
    </BrowserRouter>
  );
 }
}

export default App;
